<template>
  <Badge v-if="licenseStatusLabel" :variant="badgeVariant()">
    <vue-feather type="shield" size="12" />
    {{ licenseStatusLabel }}
  </Badge>
</template>

<script setup lang="ts">
import { Badge } from '@/components/ui/badge';
import type { BadgeVariants } from '@/components/ui/badge';
import type { LicenseStatusLabel } from '@/types/LicenseStatusLabel';

const { licenseStatusLabel } = defineProps<{
  licenseStatusLabel: LicenseStatusLabel;
}>();

const badgeVariants = new Map<LicenseStatusLabel, BadgeVariants['variant']>([
  ['Licensed', 'green-dark'],
  ['License In Progress', 'yellow-dark'],
  ['Unlicensed', 'gray'],
  ['Unknown', 'blue-dark'],
]);

function badgeVariant(): BadgeVariants['variant'] {
  return badgeVariants.get(licenseStatusLabel)!;
}
</script>
